export enum MenuItemType {
  NONE = 'NONE',
  MACHINE = 'MACHINE',
  MACHINE_GROUP = 'MACHINE_GROUP',
  USER_DEFINED_PAGE = 'USER_DEFINED_PAGE',
  DATA_VISUALIZATION_PAGE = 'DATA_VISUALIZATION_PAGE',
  NODE = 'NODE',
  EXTERNAL_URL = 'EXTERNAL_URL',
  FORM_PAGE = 'FORM_PAGE',
  TABLEAU_PAGE = 'TABLEAU_PAGE',
  FRAME_PAGE = 'FRAME_PAGE',
  WEBGL_PAGE = 'WEBGL_PAGE',
  BUCKET_BROWSER_PAGE = 'BUCKET_BROWSER_PAGE',
  STATUS_EVENT_PAGE = 'STATUS_EVENT_PAGE',
  TEMPLATE_STATUS_EVENT_PAGE = 'TEMPLATE_STATUS_EVENT_PAGE',
  MACHINE_GROUP_STATUS_PAGE = 'MACHINE_GROUP_STATUS_PAGE',
  USER_SHARED_PAGE = 'USER_SHARED_PAGE',
  LOOKER_PAGE = 'LOOKER_PAGE',
  TEMPLATE_USER_DEFINED_PAGE = 'TEMPLATE_USER_DEFINED_PAGE'
}
